import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close\"><path d=\"M783.904 265.152L743.904 224l-240 246.848-239.456-246.272-40 41.12L463.936 512 224 758.72l40 41.152 239.904-246.752 240 246.848 40-41.152-240-246.848 240-246.848z\" fill=\"#000000\" fill-opacity=\".9\" p-id=\"8852\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol